import { render, staticRenderFns } from "./FooterNotesByDomain.vue?vue&type=template&id=2aae1fc7&"
import script from "./FooterNotesByDomain.vue?vue&type=script&lang=js&"
export * from "./FooterNotesByDomain.vue?vue&type=script&lang=js&"
import style0 from "./FooterNotesByDomain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports